import { useEffect, useState } from "react";
import { MessageCircle, Heart, Lock, Gift } from "lucide-react";
import { api } from "../../lib/api";
import { Reveal } from "../Reveal";

const cell = "relative overflow-hidden border border-[#0E1B3D]/[0.08] bg-[#FFFFFF] group";

const ImgCell = ({ src, className, label, testid, contain = false }) => (
  <div data-testid={testid} className={`${cell} ${className} min-h-[320px]`}>
    {contain && <img src={src} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-70" />}
    <img src={src} alt="" className={`absolute inset-0 w-full h-full ${contain ? "object-contain" : "object-cover object-[50%_20%]"} transition-transform duration-[1600ms] ease-out group-hover:scale-105`} />
    <div className="absolute inset-0 bg-gradient-to-t from-[#FFF8EE]/80 via-transparent via-25% to-transparent" />
    <p className="absolute left-6 bottom-6 font-display italic text-2xl text-[#0E1B3D]">{label}</p>
  </div>
);

export function Bento() {
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    api.get("/public/summary").then((r) => setSummary(r.data)).catch(() => setSummary(null));
  }, []);
  const posts = summary?.posts ?? null;

  return (
    <section id="inside" data-testid="bento-section" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:pt-36 sm:pb-16">
      <Reveal className="grid lg:grid-cols-12 gap-8 mb-14">
        <p className="eyebrow lg:col-span-3">01 — Inside</p>
        <h2 className="lg:col-span-9 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.1] text-[#0E1B3D] max-w-3xl">
          No algorithm, no middleman. <span className="italic text-[#D7263D]">Just Katie</span> and the people who chose to be here.
        </h2>
      </Reveal>
      <Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-4 lg:grid-rows-[300px_300px] gap-4">
          <ImgCell testid="bento-cell-feed" src="/img/p1.jpg" label="The members feed" className="lg:col-span-2 lg:row-span-2 min-h-[480px]" contain />
          <div data-testid="bento-cell-count" className={`${cell} p-8 flex flex-col justify-between min-h-[260px]`}>
            <Heart className="w-6 h-6 text-[#D7263D]" />
            <div>
              <p className="font-display text-6xl text-[#0E1B3D]">{posts ?? "—"}</p>
              <p className="mt-2 text-sm text-[#4A5878]">posts waiting behind the door. Like & comment on every one.</p>
            </div>
          </div>
          <ImgCell testid="bento-cell-vault" src="/img/p4.jpg" label="Fresh drops" className="" />
          <div data-testid="bento-cell-dm" className={`${cell} lg:col-span-2 p-8 grid sm:grid-cols-2 gap-8 min-h-[260px]`}>
            <div className="flex flex-col justify-between gap-6">
              <MessageCircle className="w-6 h-6 text-[#D7263D]" />
              <div>
                <h3 className="font-display text-2xl text-[#0E1B3D]">Direct messages</h3>
                <p className="mt-2 text-sm text-[#4A5878] leading-relaxed">Every member gets a private line straight to Katie's inbox.</p>
              </div>
            </div>
            <div className="flex flex-col justify-between gap-6 sm:border-l sm:border-[#0E1B3D]/10 sm:pl-8">
              <Gift className="w-6 h-6 text-[#D7263D]" />
              <div>
                <h3 className="font-display text-2xl text-[#0E1B3D]">Tips & tiers</h3>
                <p className="mt-2 text-sm text-[#4A5878] leading-relaxed">Send a tip on any post. Some posts stay <Lock className="inline w-3.5 h-3.5 -mt-0.5" /> locked until you level up — or unlock them one by one.</p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
